import { render, staticRenderFns } from "./TrackShipmentStatus.vue?vue&type=template&id=0afaffb8&scoped=true&"
import script from "./TrackShipmentStatus.vue?vue&type=script&lang=js&"
export * from "./TrackShipmentStatus.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./TrackShipmentStatus.vue?vue&type=style&index=0&id=0afaffb8&lang=css&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0afaffb8",
  null
  ,true
)

export default component.exports